import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { brandPage } from "@faire/retailer-visitor-shared/paths/index";
import { BrandReview } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageBrandReviewTile/__internal__/BrandReview";
import { BrandReviewTileImages } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageBrandReviewTile/__internal__/BrandReviewTileImages";
import { Avatar } from "@faire/web--source/slate/deprecated/Avatar";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { NoTranslate, StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackSeoSuppliersPageMostPopularCarouselBrandClick } from "@faire/web-api--source/events/seo/click/suppliersPageMostPopularCarouselBrand";
import { trackSeoSuppliersPageMostPopularCarouselProductTileClick } from "@faire/web-api--source/events/seo/click/suppliersPageMostPopularCarouselProductTile";
import React from "react";
import styled from "styled-components";
export var BrandReviewWithCommentTile = function(param) {
    var item = param.item, onClick = param.onClick;
    var brand_name = item.brand_name, brand_image = item.brand_image, brand_token = item.brand_token, products = item.products, order_count = item.order_count;
    return /*#__PURE__*/ _jsxs(BorderColumn, {
        children: [
            /*#__PURE__*/ _jsx(BrandReviewTileImages, {
                brandName: brand_name,
                products: products,
                brandToken: brand_token,
                onProductClick: function(productToken) {
                    trackSeoSuppliersPageMostPopularCarouselProductTileClick(productToken);
                    onClick === null || onClick === void 0 ? void 0 : onClick(productToken);
                }
            }),
            /*#__PURE__*/ _jsx(Link, {
                to: brandPage(brand_token !== null && brand_token !== void 0 ? brand_token : ""),
                onClick: function() {
                    trackSeoSuppliersPageMostPopularCarouselBrandClick(brand_token !== null && brand_token !== void 0 ? brand_token : "");
                    onClick === null || onClick === void 0 ? void 0 : onClick(brand_token !== null && brand_token !== void 0 ? brand_token : "");
                },
                children: /*#__PURE__*/ _jsxs(Content, {
                    children: [
                        /*#__PURE__*/ _jsxs(CenterItemsRow, {
                            children: [
                                /*#__PURE__*/ _jsx(Avatar, {
                                    size: "small",
                                    image: brand_image,
                                    altTag: brand_name
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    width: "2x"
                                }),
                                /*#__PURE__*/ _jsxs(Column, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            maxLines: 1,
                                            variant: "paragraphSansMedium",
                                            children: /*#__PURE__*/ _jsx(NoTranslate, {
                                                children: brand_name
                                            })
                                        }),
                                        order_count ? /*#__PURE__*/ _jsx(Typography, {
                                            maxLines: 1,
                                            color: Core.text.subdued,
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "JiDpiE",
                                                defaultMessage: [
                                                    {
                                                        type: 6,
                                                        value: "orderCountNumber",
                                                        options: {
                                                            one: {
                                                                value: [
                                                                    {
                                                                        type: 7
                                                                    },
                                                                    {
                                                                        type: 0,
                                                                        value: " order this month"
                                                                    }
                                                                ]
                                                            },
                                                            other: {
                                                                value: [
                                                                    {
                                                                        type: 7
                                                                    },
                                                                    {
                                                                        type: 0,
                                                                        value: " orders this month"
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        offset: 0,
                                                        pluralType: "cardinal"
                                                    }
                                                ],
                                                values: {
                                                    orderCountNumber: order_count
                                                }
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(BrandReview, {
                            item: item
                        })
                    ]
                })
            })
        ]
    });
};
var Content = styled(Column).withConfig({
    componentId: "sc-d1398e8a-0"
})([
    "padding:",
    ";"
], getSpacing("2x"));
var CenterItemsRow = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-d1398e8a-1"
})([
    ""
]);
var BorderColumn = styled(Column).withConfig({
    componentId: "sc-d1398e8a-2"
})([
    "border:1px solid ",
    ";height:100%;"
], Core.border.muted);
